import { PageContainer, SegmentedProgress, Surface, Text } from "@/components/ui"
import { TRANSITION } from "@/lib/motion"
import { AnimatePresence, motion, useReducedMotion } from "motion/react"
import { CheckoutStep, STEP_LABELS, getVisibleSteps } from "../state"

type StepperProps = {
  currentStep: CheckoutStep
  hasExtras?: boolean
  isTableOrder?: boolean
  showTiming?: boolean
  showSchedule?: boolean
}

export function Stepper({
  currentStep,
  hasExtras = true,
  isTableOrder = false,
  showTiming = false,
  showSchedule = false,
}: StepperProps) {
  const visibleSteps = getVisibleSteps({
    hasExtras,
    isTableOrder,
    showTiming,
    showSchedule,
  })
  const currentIndex = Math.max(0, visibleSteps.indexOf(currentStep))
  const total = visibleSteps.length
  const reduceMotion = useReducedMotion()

  return (
    <Surface surface="card">
      <PageContainer className="pb-4 pt-1">
        <Text size="base" weight="semibold" tone="muted" className="mb-2 overflow-hidden" aria-live="polite" aria-atomic="true">
          <AnimatePresence mode="wait" initial={false}>
            <motion.span
              key={currentStep}
              className="inline-block"
              initial={reduceMotion ? { opacity: 0 } : { y: 12, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              exit={reduceMotion ? { opacity: 0 } : { y: -12, opacity: 0 }}
              transition={TRANSITION.fade}
            >
              Passo {currentIndex + 1} de {total}, {STEP_LABELS[currentStep]}
            </motion.span>
          </AnimatePresence>
        </Text>
        <SegmentedProgress segments={total} current={currentIndex} />
      </PageContainer>
    </Surface>
  )
}
